import { useState } from "react";
import { X, Send } from "lucide-react";
import { toast } from "sonner";
import api, { errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function ContactModal({ open, onClose, company, resource, defaultDate, mode = "contact" }) {
  const { user } = useAuth();
  const isReservation = mode === "reservation";
  const [form, setForm] = useState({
    name: user ? `${user.name} ${user.surname}`.trim() : "",
    phone: user?.phone || "",
    email: user?.email || "",
    event_date: defaultDate || "2027-08-15",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  if (!open) return null;

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact-requests", {
        company_id: company.id,
        resource_id: resource?.id || null,
        type: mode,
        ...form,
      });
      toast.success(isReservation ? "Rezervasyon isteğiniz firmaya gönderildi." : "İletişim talebiniz firmaya gönderildi.");
      onClose();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" data-testid="contact-modal" onClick={onClose}>
      <div className="card w-full max-w-md p-6 relative" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-4 right-4 text-slate-400 hover:text-white" data-testid="contact-modal-close"><X size={20} /></button>
        <h3 className="text-xl font-bold text-white mb-1">{isReservation ? "Rezervasyon İsteği" : "İletişime Geç"}</h3>
        <p className="text-sm text-slate-400 mb-5">{company.name}{resource ? ` — ${resource.name}` : ""}</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="label">Ad Soyad</label>
            <input data-testid="contact-name" className="input" required value={form.name} onChange={set("name")} />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="label">Telefon</label>
              <input data-testid="contact-phone" className="input" required value={form.phone} onChange={set("phone")} />
            </div>
            <div>
              <label className="label">E-posta</label>
              <input data-testid="contact-email" type="email" className="input" required value={form.email} onChange={set("email")} />
            </div>
          </div>
          <div>
            <label className="label">Etkinlik Tarihi</label>
            <input data-testid="contact-event-date" type="date" className="input" value={form.event_date} onChange={set("event_date")} />
          </div>
          <div>
            <label className="label">Mesajınız</label>
            <textarea data-testid="contact-message" className="input min-h-[90px]" value={form.message} onChange={set("message")} placeholder="Etkinliğiniz hakkında kısaca bilgi verin..." />
          </div>
          <button data-testid="contact-submit-btn" disabled={loading} className="btn-gold w-full">
            <Send size={16} /> {loading ? "Gönderiliyor..." : isReservation ? "Rezervasyon İsteği Gönder" : "Talebi Gönder"}
          </button>
        </form>
      </div>
    </div>
  );
}
